import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { PanelIcon } from '../../user-panel';
import { Field } from '../panel-ui';

const SUPPORT_EMAIL = 'office@halostan.rs';
const SUPPORT_PHONE = '062 048 423';

export const ContactSupport = () => {
    const { t } = useTranslation(["profile"]);
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");

    const canSend = message.trim().length > 0;
    // there is no contact endpoint, so the message is handed to the user's mail program
    const mailto = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(message)}`;

    return (
        <section className='hs hs-panel-page'>
            {/* the quickest ways first: a tap calls or opens the mail */}
            <div className='hs-panel-contact'>
                <h2>{t('contact_title')}</h2>
                <div className='hs-panel-contact-tiles'>
                    <a className='hs-panel-contact-tile' href={`tel:${SUPPORT_PHONE.replace(/\s/g, '')}`}>
                        <span className='hs-panel-form-icon blue'><PanelIcon name='phone' /></span>
                        <span className='hs-panel-contact-label'>{t('contact_call_title')}</span>
                        <span className='hs-panel-contact-value'>{SUPPORT_PHONE}</span>
                    </a>
                    <a className='hs-panel-contact-tile' href={`mailto:${SUPPORT_EMAIL}`}>
                        <span className='hs-panel-form-icon blue'><PanelIcon name='mail' /></span>
                        <span className='hs-panel-contact-label'>{t('contact_mail_title')}</span>
                        <span className='hs-panel-contact-value'>{SUPPORT_EMAIL}</span>
                    </a>
                </div>
                <span className='hs-panel-row-sub'>{t('contact_hours')}</span>
            </div>

            <div className='hs-panel-card hs-panel-form'>
                <h2>{t('contact_form_title')}</h2>
                <Field label={t('contact_subject')} type='text' maxLength={200} value={subject} onChange={(e) => setSubject(e.target.value)} />
                <label className='hs-panel-field'>
                    <span className='hs-panel-field-label'>{t('contact_message')}</span>
                    <textarea rows={5} value={message} onChange={(e) => setMessage(e.target.value)} />
                </label>
                <span className='hs-panel-row-sub'>{t('contact_hint')}</span>
                <a className={`hs-panel-primary hs-panel-contact-send ${canSend ? '' : 'disabled'}`} href={canSend ? mailto : undefined} aria-disabled={!canSend}>{t('contact_send')}</a>
            </div>
        </section>
    );
};
